<template>
  <v-card>
    <v-card-title>
      <v-row>
        <v-col cols="12">
          <v-btn @click="goBack">
            <v-icon>
              mdi-arrow-left
            </v-icon>
            Назад
          </v-btn>
        </v-col>
        <v-col cols="12">
          Добавление запчасти
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-form v-model="valid">
        <v-container>
          <v-row>
            <v-col cols="12" sm="3">
              <v-text-field
                  v-model="form.name"
                  label="Наименование"
                  dense
                  required
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                  v-model="form.vendorCode"
                  label="Артикул"
                  dense
                  required
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-select v-model="form.spareBrandId" :items="brands" item-value="id" item-text="name" label="Бренд" dense>
              </v-select>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                  v-model="form.amount"
                  label="Количество"
                  type="number"
                  dense
                  required
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                  v-model="form.price"
                  label="Цена"
                  type="number"
                  dense
                  required
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                  v-model="form.dealerPrice"
                  label="Дилерская цена"
                  type="number"
                  dense
                  required
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-file-input
                  v-model="photo"
                  label="Фото запчасти"
                  truncate-length="15"
                  dense
              ></v-file-input>
            </v-col>
            <v-col cols="12" sm="3">
              <v-select v-model="form.isForSale" :items="selects" label="Для продажи" dense />
            </v-col>
            <v-col cols="12" sm="3">
              <v-select v-model="form.isHidden" :items="selects" label="Скрыть" dense />
            </v-col>
          </v-row>
          <v-simple-table v-if="characters.length > 0">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left">
                  Наименование
                </th>
                <th class="text-left">
                  Значение
                </th>
                <th class="text-left">
                </th>
              </tr>
              </thead>
              <tbody>
              <tr
                  v-for="item in characters"
                  :key="item.id"
              >
                <td>
                    <v-text-field
                      v-model="item.labelName"
                      dense
                      required
                  >
                  </v-text-field>
                </td>
                <td>
                  <v-text-field
                    v-model="item.value"
                    dense
                    required
                  >
                  </v-text-field>
                </td>
                <td>
                  <v-btn @click="deleteCharac(item.id)" fab small color="primary">
                    <v-icon>
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-container>
        <v-btn @click="addCharac" small>
          Добавить характеристики
        </v-btn>
      </v-form>
      <v-btn class="mt-4" @click="addTire" color="primary">
        Добавить
      </v-btn>
    </v-card-text>
  </v-card>
</template>
<script>

import {showSnackbar} from "@/plugins/eventBus";

export default {
  name: 'TireAdd',
  data () {
    return {
      characters: [],
      selects: ['Да', 'Нет'],
      valid: true,
      form: {
        name: '',
        spareBrandId: '',
        price: '',
        vendorCode: '',
        dealerPrice: '',
        isForSale: '',
        isHidden: '',
      },
      photo: null,
      brands: []
    }
  },
  mounted() {
    this.getTireBrands()
  },
  methods: {
    deleteCharac (id) {
      this.characters = this.characters.filter((item) => item.id !== id)
    },
    addCharac () {
      this.characters.push({id: this.characters.length, labelName: '', value: ''})
    },
    goBack () {
      this.$router.go(-1);
    },
    async getTireBrands() {
      try {
        this.brands = await this.$store.dispatch('partnerSpare/getSpareBrands')
      } catch (e) {
        console.log(e)
      }
    },
    async addTire () {
      try {
        const formData = new FormData()
        const attributeRequests = this.characters.map((item) => {
          return {
            labelName: item.labelName,
            value: item.value,
          }
        })
        formData.append('name', this.form.name)
        formData.append('vendorCode', this.form.vendorCode)
        formData.append('brandId', this.form.spareBrandId)
        formData.append('attributeRequests', JSON.stringify(attributeRequests))
        const spare = await this.$store.dispatch('partnerSpare/createSpare', formData)
        const data = {
          amount: parseInt(this.form.amount),
          dealerPrice: parseInt(this.form.dealerPrice),
          isForSale: this.form.isForSale === 'Да',
          isHidden: this.form.isHidden === 'Да',
          price: parseInt(this.form.price),
          sharePartId: spare.id
        }
        const resp = await this.$store.dispatch('partnerSpare/addPartnerSpare', data)
        showSnackbar({
          message: "Запчасть успешно добавлена!",
          color: "success",
          timeout: 3000,
        })
        console.log(resp)
        console.log(spare)
      } catch (e) {
        console.log(e)
        showSnackbar({
          message: "Не удалось добавить запчасть!",
          color: "error",
          timeout: 3000,
        })
      } finally {
        this.goBack()
      }
      console.log(this.form)
      console.log(this.photo)
    }
  }
}
</script>
<style scoped>

</style>